import { render, staticRenderFns } from "./GardenSlwct.vue?vue&type=template&id=40ae008a&scoped=true&"
import script from "./GardenSlwct.vue?vue&type=script&lang=js&"
export * from "./GardenSlwct.vue?vue&type=script&lang=js&"
import style0 from "./GardenSlwct.vue?vue&type=style&index=0&id=40ae008a&lang=scss&scoped=true&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae008a",
  null
  
)

export default component.exports